module.exports = __webpack_public_path__ + "static/media/2.9962cab5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/2.jpg
// module id = 420
// module chunks = 0